import { collection, getDocs } from 'firebase/firestore'
import { db } from '../firebase'

export async function fetchFirestoreList(collectionName) {
  try {
    const snapshot = await getDocs(collection(db, collectionName))
    const items = snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    return { items, error: null }
  } catch (error) {
    console.error(`Failed to load ${collectionName}`, error)
    return { items: [], error }
  }
}
